import { render } from "./Departments.vue?vue&type=template&id=71125620"
import script from "./Departments.vue?vue&type=script&setup=true&lang=js"
export * from "./Departments.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/company/components/Departments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71125620"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71125620', __exports__)) {
    api.reload('71125620', __exports__)
  }
  
  module.hot.accept("./Departments.vue?vue&type=template&id=71125620", () => {
    api.rerender('71125620', render)
  })

}


export default __exports__